import React, { createContext, useContext, useState } from "react";
import { useGameClub } from "./useGameClub";
import { GameClubDto } from "../../../../api/game-club";

interface GameClubContextType extends ReturnType<typeof useGameClub> {
  isClubJoin: boolean;
  setIsClubJoin: (value: boolean) => void;
  popupType: string;
  setPopupType: (value: string) => void;
  selectClubId: number;
  setSelectClubId: (value: number) => void;
  myClub: GameClubDto | null;
  setMyClub: (value: GameClubDto | null) => void;
  role: string;
  setRole: (value: string) => void;
  clubId: number;
  setClubId: (value: number) => void;
  clubUserId: number;
  setClubUserId: (value: number) => void;
  setGetData: React.Dispatch<React.SetStateAction<(() => void) | null>>;
  getData: (() => void) | null;
  myJoinRequest: GameClubDto | null;
  setMyJoinRequest: (value: GameClubDto | null) => void;
  resetUserData: boolean;
  setResetUserData: (value: boolean) => void;
}

const GameClubContext = createContext<GameClubContextType | null>(null);

export const GameClubProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const GameClubData = useGameClub();
  const [isClubJoin, setIsClubJoin] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<string>("");
  const [selectClubId, setSelectClubId] = useState<number>(0);
  const [clubId, setClubId] = useState<number>(0);
  const [clubUserId, setClubUserId] = useState<number>(0);
  const [role, setRole] = useState<string>("");
  const [myClub, setMyClub] = useState<GameClubDto | null>(null); // joined, waiting, "notJoined"
  const [getData, setGetData] = useState<(() => void) | null>(null);
  const [myJoinRequest, setMyJoinRequest] = useState<GameClubDto | null>(null);
  const [resetUserData, setResetUserData] = useState<boolean>(false);

  const value = {
    ...GameClubData,
    isClubJoin,
    setIsClubJoin,
    popupType,
    setPopupType,
    selectClubId,
    setSelectClubId,
    myClub,
    setMyClub,
    clubId,
    setClubId,
    getData,
    setGetData,
    role,
    setRole,
    clubUserId,
    setClubUserId,
    myJoinRequest,
    setMyJoinRequest,
    resetUserData,
    setResetUserData,
  };

  return (
    <GameClubContext.Provider value={value}>
      {children}
    </GameClubContext.Provider>
  );
};

export const useGameClubContext = () => {
  const context = useContext(GameClubContext);
  if (!context) {
    throw new Error("useGameContext must be used within a GameProvider");
  }
  return context;
};
